import * as CS from 'view/pages/createJobPost/commonStyled';
import { FC } from 'react';

const JobPostHeader: FC<{ title: string; subtitle?: string | undefined; style?: any }> = ({
  title,
  subtitle = '',
  style,
}) => {
  return (
    <CS.CreateJobPostMainHeader style={style}>
      <CS.CreateJobPostMainHeaderTitle component="h4">{title}</CS.CreateJobPostMainHeaderTitle>
      {subtitle && (
        <CS.CreateJobPostMainHeaderSubTitle>{subtitle}</CS.CreateJobPostMainHeaderSubTitle>
      )}
    </CS.CreateJobPostMainHeader>
  );
};

export default JobPostHeader;
